<!-- <div *ngIf="!accept_creation">

  <section class="error-area">
    <div class="error-item">
        <div class="d-table">
            <div class="d-table-cell">
                <div class="error-text">
                    <h3>Alert</h3>
                    <p>Your Profile already has a registered service!!!</p>
                    <span>Please sign out to register a new service</span>
                    <button (click)="confirmSignOut()">Sign Out</button>
                </div>
            </div>
        </div>
    </div>
  </section>

</div> -->

<!-- <div *ngIf="accept_creation"> -->
  <div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div *ngIf="!is_edit" class="page-title-text">
                    <h2>Free Service Profile</h2>
                    <ul>
                        <li><a routerLink="/">Home</a></li>
                        <li><i class="icofont-simple-right"></i></li>
                        <li><a routerLink="/register_as">Register As</a></li>
                        <li><i class="icofont-simple-right"></i></li>
                        <li>Free Service</li>
                    </ul>
                </div>
                <div *ngIf="user && is_edit" class="page-title-text">
                  <h2>Service Edit</h2>
                  <ul>
                      <li><a routerLink="/">Home</a></li>
                      <li><i class="icofont-simple-right"></i></li>
                      <li><a [routerLink]="['/profile', user.id]">Profile Detail</a></li>
                  </ul>
                </div>
            </div>
        </div>
    </div>
  </div>


  <div class="dashboard-area pt-100">
    <div class="container">
        <div class="create-information">
            <form [formGroup]="pform" (ngSubmit)="saveData()">
                <h3>{{title_main}}</h3>
                <!-- <h3 *ngIf="is_edit">{{title_sub}}</h3> -->
                <!-- This section willbe for future service/business cover photo -->
                <!-- <div class="create-information-btn">
                    <a routerLink="/">Upload Cover Photo</a>
                    <a routerLink="/">Upload Your CV</a>
                </div> -->

                <div class="row">

                     <div class="row">
                       <!-- Service Category -->
                       <div class="col-lg-6">
                        <div class="form-group">
                            <label for="serviceCategoryId">Service Category</label>
                            <ng-select
                            formControlName="serviceCategoryId"
                            [ngClass]="{'is-invalid': displayMessage.serviceCategoryId}"
                            [items]="categories"
                            bindLabel="name"
                            bindValue="id">
                            </ng-select>
                            <span class="invalid-feedback">
                              {{displayMessage.serviceCategoryId}}
                            </span>
                        </div>
                      </div>

                      <!-- Service Name -->
                      <div class="col-lg-6">
                        <div class="form-group">
                            <label for="name">Service/Business Name</label>
                            <input type="text" class="form-control"
                            id="name" placeholder="or name of a person offering service"
                            formControlName="name"
                            [ngClass]="{'is-invalid': displayMessage.name }">
                            <span class="invalid-feedback">
                              {{displayMessage.name}}
                            </span>
                        </div>
                      </div>

                     </div>

                     <div class="row">
                       <!-- Address Line -->
                       <div class="col-lg-6">
                        <div class="form-group">
                          <label for="line">Address:</label>
                            <input type="text" class="form-control"
                            id="line" placeholder="Service/Business address"
                            formControlName="line"
                            [ngClass]="{'is-invalid': displayMessage.line }">
                            <span class="invalid-feedback">
                              {{displayMessage.line}}
                            </span>
                        </div>
                      </div>

                      <!-- Country -->
                      <div class="col-lg-6">
                        <div class="form-group">
                          <label for="city">Country:</label>
                          <ng-select
                              formControlName="country"
                              [ngClass]="{'is-invalid': displayMessage.country}"
                              [items]="countries"
                              bindLabel="name"
                              bindValue="shortName">
                              </ng-select>
                              <span class="invalid-feedback">
                                {{displayMessage.city}}
                              </span>
                        </div>
                      </div>
                     </div>

                    <div *ngIf="country.value != null" class="row">
                      <div class="col-lg-6">
                        <div class="form-group">
                          <label for="city">State:</label>
                          <ng-select
                              formControlName="state"
                              [ngClass]="{'is-invalid': displayMessage.state}"
                              [items]="states"
                              bindLabel="state"
                              bindValue="state">
                              </ng-select>
                              <span class="invalid-feedback">
                                {{displayMessage.city}}
                              </span>
                        </div>
                      </div>

                      <div *ngIf="state.value != null" class="col-lg-6">
                        <div class="form-group">
                          <label for="city">City:</label>
                          <ng-select
                              formControlName="city"
                              [ngClass]="{'is-invalid': displayMessage.city}"
                              [items]="cities"
                              bindLabel="city"
                              bindValue="city">
                              </ng-select>
                              <span class="invalid-feedback">
                                {{displayMessage.city}}
                              </span>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                        <!-- Description -->
                        <div class="col-lg-6">
                          <div class="form-group">
                              <label>Description</label>
                              <textarea id="your_message" class="form-control" rows="8"
                                formControlName="description"
                               placeholder="Decscribe the nature of your business/service or keywords associated with your business/service"></textarea>
                          </div>
                        </div>

                        <!-- Contact Number -->
                        <div class="col-lg-6">
                            <div class="form-group">
                                <label for="contactNumber">Service/Business Primary Contact</label>
                                <input type="text" class="form-control"
                                id="contactNumber" placeholder="08147526931"
                                formControlName="contactNumber"
                                [ngClass]="{'is-invalid': displayMessage.contactNumber }">
                                <span class="invalid-feedback">
                                  {{displayMessage.contactNumber}}
                                </span>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="text-left">
                  <button type="submit" class="btn create-ac-btn"
                    [title]="pform.valid"
                    [disabled]="!pform.valid">
                    Save</button>
                </div>

            </form>
        </div>

    </div>
  </div>
<!-- </div> -->


<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#40a834" type = "line-scale" [fullScreen] = "true">
  <p style="color: rgb(250, 242, 242)" > Loading... </p>
</ngx-spinner>
